<template>
  <div class="cashback-customers-use-metrics card">
    <template v-if="$_verifyLoaded('done')">
      <h3 class="ccm__title" v-html="$t('360.cashback-report.customers-use.title')"></h3>
      <div class="ccm__metrics">
        <div v-for="(metric, key) in metrics" :key="key" class="ccm__metric">
          <h4 class="ccm__metric-title">{{ metric.title }}</h4>
          <p class="ccm__metric-amount">{{ formatMetric(metric) }}</p>
        </div>
      </div>
    </template>
    <base-loader v-show="$_verifyLoaded('loading')" />
    <info-card v-show="$_verifyLoaded('info')" ref="message-error" :error="hasError" :height="'45px'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getMetrics } from '@/services/oto/cashbackReport';

// helpers
import bus from '@/helpers/events/bus';
import { valuesByFormat } from '@/utilities/formatters';
import { verifyMixin } from '@/helpers/mixins';

import BaseLoader from '@/components/_atoms/BaseLoaderSpinner';
import InfoCard from '@/components/_atoms/InfoCard';

export default {
  name: 'CashbackCustomersUseMetrics',
  components: {
    BaseLoader,
    InfoCard,
  },
  mixins: [verifyMixin],

  data() {
    return {
      metrics: [],
    };
  },

  computed: {
    ...mapGetters('cashbackReport', ['getStoreId', 'getSellerId']),
  },

  mounted() {
    this.fetchData();

    // bus called when dates are changed globally
    bus.$on('render-cards', () => {
      this.fetchData();
    });
    bus.$on('cashback-report-change-store', () => {
      this.fetchData();
    });
    bus.$on('cashback-report-change-seller', () => {
      this.fetchData();
    });
    bus.$on('cashback-report-change-segment-general', () => {
      this.fetchData();
    });
  },

  beforeUnmount() {
    bus.$off('cashback-report-change-segment-general');
    bus.$off('cashback-report-change-seller');
    bus.$off('render-cards');
    bus.$off('cashback-report-change-store');
  },

  methods: {
    fetchData() {
      this.$_reqConfig();

      getMetrics({
        metrics: 'aov,frequency,recency',
        type: 'used',
        storeId: this.getStoreId,
        sellerId: this.getSellerId,
      })
        .then(({ data }) => {
          this.$_verifyHasData(data.data);

          this.metrics = data.data;
        })

        .catch(() => {
          this.hasError = true;
          this.$_componentHeight();
        })

        .finally(() => {
          this.loading = false;
        });
    },
    formatMetric(metric) {
      return valuesByFormat(metric?.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.cashback-customers-use-metrics {
  height: 135px;
  // margin-left: 10px;
  box-sizing: border-box;

  .ccm__title {
    font-size: 18px;
    color: $gray-800;
  }

  .ccm__metrics {
    display: flex;
  }

  .ccm__metric {
    margin: 5px 20px 0 20px;

    &:first-child {
      margin-left: 2px;
    }

    .ccm__metric-title {
      font-weight: 600;
      color: $gray-700;
      font-size: 12px;
      margin: 0;
      padding-top: 5px;
    }

    .ccm__metric-amount {
      color: $oto-omni;
      font-weight: 600;
      font-size: 16px;
      padding-top: 10px;
      margin: 0;
    }
  }
}
</style>

<style lang="scss">
.cashback-customers-use-metrics .ccm__title {
  span {
    color: $oto-seller;
  }
}
</style>
